import React from 'react';
import {
    CheckboxContainer,
    CheckboxWrapper,
    HiddenCheckbox,
    StyledCheckbox,
    Label,
    ErrorMessage,
    HelperText,
} from './styles';
import { CheckboxProps } from './types';

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, error, helperText, variant = 'default', size = 'md', className, checked, ...props }, ref) => {
        const effectiveVariant = error ? 'error' : variant;
        const isChecked = checked ?? false;

        return (
            <CheckboxContainer className={className}>
                <CheckboxWrapper $disabled={props.disabled}>
                    <HiddenCheckbox
                        ref={ref}
                        checked={isChecked}
                        {...props}
                    />
                    <StyledCheckbox
                        $checked={isChecked}
                        $variant={effectiveVariant}
                        $size={size}
                        $disabled={props.disabled}
                    />
                    {label && <Label $disabled={props.disabled}>{label}</Label>}
                </CheckboxWrapper>
                {error && <ErrorMessage>{error}</ErrorMessage>}
                {!error && helperText && <HelperText>{helperText}</HelperText>}
            </CheckboxContainer>
        );
    }
);

Checkbox.displayName = 'Checkbox';

export type { CheckboxProps } from './types';
